import 'react-app-polyfill/ie11'
import 'react-app-polyfill/stable'
import React from 'react'
import * as Sentry from '@sentry/browser'
import ReactDOM from 'react-dom'
import { BrowserRouter } from 'react-router-dom'
import { AppContainer } from 'react-hot-loader'
import App from './App'
import { CookiesProvider } from 'react-cookie'

import { ConfigProvider } from 'antd'
import koKR from 'antd/lib/locale/ko_KR'

Sentry.init({ dsn: 'https://b65c3d29003144f6ad5e24d4a997736b@sentry.io/1768806' })

const render = (Component) => {
    ReactDOM.hydrate(
        <ConfigProvider locale={koKR}>
            <div className="app_wrap">
                <AppContainer>
                    <BrowserRouter>
                        <CookiesProvider>
                            <Component data={window.__PRELOADED_STATE__} />
                        </CookiesProvider>
                    </BrowserRouter>
                </AppContainer>
            </div>
        </ConfigProvider>,
        document.getElementById('reactbody')
    )
}

render(App)

if (module.hot) {
    module.hot.accept('./App', () => {
        // eslint-disable-next-line
        const nextApp = require('./App').default
        render(nextApp)
    })
}

// module.hot.accept('./reducers', () => {
//   // eslint-disable-next-line
//   const nextRootReducer = require('./reducers/index');
//   store.replaceReducer(nextRootReducer);
// });



// WEBPACK FOOTER //
// ./Src/index.js